import { getCmsMonthlyPassOffers } from "../../../app/api/getCmsMonthlyPassOffers";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsMonthlyPassOfferResponse } from "../../../Orchestrator/Types/Interface/ICMSOffers";

class GetCmsMonthlyPassOfferAction extends BaseAction<ICmsMonthlyPassOfferResponse | null, void> {
  override async run(): Promise<ICmsMonthlyPassOfferResponse | null> {
    let result: ICmsMonthlyPassOfferResponse | null = null;

    try {
      const response = await getCmsMonthlyPassOffers();

      if (response.status === "ok" && response.answer) {
        result = response.answer;
      } else {
        console.warn("Failed to fetch monthly pass offer.");
      }
    } catch {
      console.error("Failed to fetch monthly pass offer");
    } finally {
      updateRecoilState("cmsMonthlyPassOfferResponseAtom", result);
      return result
    }
  }
}

export const getCmsMonthlyPassOfferAction = new GetCmsMonthlyPassOfferAction();
